module.exports = __webpack_public_path__ + "6a9c7121fab26525e9f22a53a51c0e11.png";